<script setup>
defineProps({
  bw: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <img
    src="/images/askbro-logo.svg"
    alt="AskBro"
    width="66"
    height="102"
    decoding="async"
    class="block object-contain"
    :class="bw ? 'brightness-0 invert' : ''"
  />
</template>
